import React from "react";
import {Box, Chip} from "@material-ui/core";
import {Timestamp} from "api/firebase";
import {format} from "date-fns";
import clsx from "clsx";
import {useStyles} from "./style";
import Avatar from "../../../Avatar";

type ConversationItemProps = {
  standId: string;
  standName: string;
  subTitle: string;
  selectedConversationId: string;
  selectConversation: (id: string) => void;
  timestamp: Timestamp;
  unread: number;
  imgUrl?: string;
  lastMessage?: string;
};

const ConversationItem = ({
  standId,
  standName,
  subTitle,
  selectedConversationId,
  selectConversation,
  imgUrl,
  lastMessage,
  timestamp,
  unread,
}: ConversationItemProps) => {
  const classes = useStyles();

  const time =
    timestamp && timestamp.seconds
      ? format(timestamp.seconds * 1000, "HH:mm")
      : "";
  return (
    <Box
      onClick={() => selectConversation(standId)}
      className={clsx(classes.conversation, {
        [classes.selectedConversation]: selectedConversationId === standId,
      })}
    >
      <Box
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box style={{display: "flex", flexDirection: "row"}}>
          <Avatar
            img={imgUrl as string}
            name={standName.replace(/[()]/g, "")}
          />
          <Box marginLeft="16px">
            <Box width={140} fontWeight={500} className={classes.truncate}>
              {`${standName}`}{" "}
            </Box>
            <Box className={classes.subName}>Exhibitor</Box>
          </Box>
        </Box>
        <Box className={classes.subName}>{time}</Box>
      </Box>
      <Box className={classes.lasMessage}>
        {lastMessage}{" "}
        {unread > 0 && (
          <Chip
            className={classes.badge}
            color="secondary"
            size="small"
            label={unread}
          />
        )}
      </Box>
      <Box className={classes.split} />
    </Box>
  );
};

export default ConversationItem;
